import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button, OverlayTrigger, Popover as RBPopover
} from 'react-bootstrap';

/**
 * Popover component is used to display a popover
 * @class Popover
 * @extends {Component}
 */
class Popover extends Component {
  static propTypes = {
    /** Determines position of popover relative to the trigger component */
    placement: PropTypes.oneOf([
      'top', 'left', 'bottom', 'right',
    ]),
    /** JSX body of the popover */
    body: PropTypes.object,
    /** Element that triggers the popover */
    trigger: PropTypes.object,
    /** How the element gets triggered (click, hover, etc.) */
    triggerType: PropTypes.oneOfType([PropTypes.string, PropTypes.array,]),
  };

  static defaultProps = {
    placement: 'top',
    body: <div>Insert <strong>markup</strong> here!</div>,
    trigger: <Button bsStyle='link'>More options</Button>,
    triggerType: 'click',
  };

  render() {
    const {
      placement, body, trigger,
    } = this.props;

    const popover = (
      <RBPopover id={`popover-positioned-${placement}`}>
        {body}
      </RBPopover>
    );

    return (
      <OverlayTrigger
        trigger={this.props.triggerType}
        rootClose placement={placement}
        overlay={popover}
      >
        {trigger}
      </OverlayTrigger>
    );
  }
}

export default Popover;
